import { render, staticRenderFns } from "./PageDataSkeleton.vue?vue&type=template&id=469a7b2c&scoped=true&"
import script from "./PageDataSkeleton.vue?vue&type=script&lang=js&"
export * from "./PageDataSkeleton.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/page-data-skeleton.css?vue&type=style&index=0&id=469a7b2c&prod&scoped=true&lang=css&"
import style1 from "@assets/css/page-data-section.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469a7b2c",
  null
  
)

export default component.exports